__turbopack_context__.v({
  "accordionSlideOverwrite": "calculatorOutputCard-module-scss-module__SBxyDa__accordionSlideOverwrite",
  "calculatorOutputCard": "calculatorOutputCard-module-scss-module__SBxyDa__calculatorOutputCard",
  "fadeIn": "calculatorOutputCard-module-scss-module__SBxyDa__fadeIn",
  "fadeOut": "calculatorOutputCard-module-scss-module__SBxyDa__fadeOut",
  "label": "calculatorOutputCard-module-scss-module__SBxyDa__label",
  "scaleIn": "calculatorOutputCard-module-scss-module__SBxyDa__scaleIn",
  "scaleOut": "calculatorOutputCard-module-scss-module__SBxyDa__scaleOut",
  "value": "calculatorOutputCard-module-scss-module__SBxyDa__value",
  "zoomIn": "calculatorOutputCard-module-scss-module__SBxyDa__zoomIn",
  "zoomOut": "calculatorOutputCard-module-scss-module__SBxyDa__zoomOut",
});
